import { useSuspenseQuery } from '@tanstack/react-query'

import { GetPropostaRevisarService } from '@/features/proposta/brasil/http/get-proposta-revisar.service'
import type { TGetPropostaRevisarResponse } from '@/features/proposta/brasil/types/proposta.type'
import { propostaKeys } from '@/features/proposta/brasil/utils'

export const useSuspensePropostaRevisar = (numero: number) => {
  return useSuspenseQuery<TGetPropostaRevisarResponse>({
    queryKey: propostaKeys.revisar(numero),
    queryFn: () => new GetPropostaRevisarService().execute(numero).then((response) => response.data),
  })
}
